import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import _ from "underscore";
import Radio from "./radio";
import BasicUtils from "../../utils/basic-utils";

class BooleanRadio extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    trueLabel: PropTypes.string,
    falseLabel: PropTypes.string,
  };

  static defaultProps = {
    trueLabel: "Yes",
    falseLabel: "No",
    onChange: _.noop,
  };

  render() {
    // radio group name needs to be unique because could be multiple boolean
    // radio groups in filters
    const name = BasicUtils.randomKey().toString();

    return (
      <fieldset className={classNames(this.props.className, "et--boolean-radio")}>
        <Radio
          checked={this.props.value === true}
          disabled={this.props.disabled}
          onChange={() => this.props.onChange(this.props.name, true)}
          name={name}
          label={this.props.trueLabel}
          value={true}
        />
        <Radio
          checked={this.props.value === false}
          disabled={this.props.disabled}
          onChange={() => this.props.onChange(this.props.name, false)}
          name={name}
          label={this.props.falseLabel}
          value={false}
        />
      </fieldset>
    );
  }
}

export default BooleanRadio;
